import template from './time-title-list.html';
import controller from './time-title-list.controller';

let timeTitleListComponent = {
  bindings: {},
  template,
  controller
};

export default timeTitleListComponent;



// WEBPACK FOOTER //
// ./client/app/components/title-time/time-title-list.component.js